import {
  Divider,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  InlineDrawer,
} from "@fluentui/react-components";
import { sizes } from "library/constants";
import { ROUTES } from "library/routes";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { BenefitsIcon } from "components/AppLayout/icons/BenefitsIcon";
import { DashboardIcon } from "components/AppLayout/icons/DashboardIcon";
import { WalletIcon } from "components/AppLayout/icons/WalletIcon";
import { SelectClient } from "components/SelectClient/SelectClient";
import { helpAnchor } from "help/anchor";
import { Flex } from "components/styled";
import { useAppTheme } from "hooks/useAppTheme";
import { useIsMobile } from "hooks/useIsMobile";

import { EmployeeProfile } from "./EmployeeProfile/EmployeeProfile";
import { NavFooter } from "./NavFooter";
import { NavItem } from "./NavItem";

export const AppNavigation = () => {
  const { t } = useTranslation();
  const theme = useAppTheme();

  const pathname = useLocation()?.pathname;
  const isDesktop = !useIsMobile();

  const isHomePage = pathname === ROUTES.HOME;
  const isPaletteDemo = pathname === "/palette-demo";

  if (!isDesktop || isHomePage || isPaletteDemo) return null;

  return (
    <InlineDrawer
      separator
      position={"start"}
      open={isDesktop}
      style={{
        width: sizes.appNavWidthDesktop + "px",
        minWidth: sizes.appNavWidthDesktop + "px",
        maxWidth: sizes.appNavWidthDesktop + "px",
        border: `1px solid  ${theme.palette.neutralLight}`,
        borderRadius: "8px",
        backgroundColor: theme.palette.white,
      }}
    >
      <DrawerHeader
        style={{
          borderBottom: `1px solid  ${theme.palette.neutralLight}`,
          paddingBottom: "20px",
          width: "300px",
        }}
      >
        <DrawerHeaderTitle>
          <SelectClient />
        </DrawerHeaderTitle>
      </DrawerHeader>

      <DrawerBody
        style={{
          borderBottom: `1px solid  ${theme.palette.neutralLight}`,

          padding: "0px",
        }}
      >
        <Flex dir="column" $gap={"10px"} style={{ padding: "20px" }}>
          <NavItem
            label={t("hbh.benefits.label")}
            pageRoute={ROUTES.BENEFITS}
            PageIcon={BenefitsIcon}
            helpAnchorName={helpAnchor("nav-benefits")}
          />
          <NavItem
            pageRoute={ROUTES.DASHBOARD}
            label={t("hbh.dashboard.label")}
            PageIcon={DashboardIcon}
            helpAnchorName={helpAnchor("nav-dashboard")}
          />
          {/* <NavItem
            disabled
            pageRoute={ROUTES.WALLET}
            label={t("hbh.wallet.label")}
            PageIcon={WalletIcon}
          /> */}
        </Flex>
        <Divider />
        <EmployeeProfile />
      </DrawerBody>
      <NavFooter />
    </InlineDrawer>
  );
};
